import { AudienceFilter, defineTopic } from 'magpie-lib/models';
import { tourMessages } from './tour.messages';
import { syncMessages } from './sync.messages';
export const TOUR_TOPIC = '@nav-onboarding-tour/TOUR_TOPIC';
export const audienceFilter = AudienceFilter.builder();
export const tourTopic = defineTopic({
  name: TOUR_TOPIC,
  messages: [tourMessages.startTour, syncMessages.partyAlive],
  enableRuntimeValidation: false,
  audience: audienceFilter.build()
});